import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { CITIES_AUTO_COMPLETE_REQUEST, CITIES_AUTO_COMPLETE_SUCCESSFUL, CITIES_AUTO_COMPLETE_FAILURE } from 'action-creators/citiesAutocomplete';
import { RESET } from 'action-creators/generic';
import { CityAutoComplete } from 'models/cityAutoComplete';

export interface CitiesAutoCompleteState {
  isLoading: boolean;
  bySearch: CityAutoComplete[];
  error: string | null;
}

const initialState: CitiesAutoCompleteState = {
  isLoading: false,
  bySearch: [],
  error: null,
};

const reducer: Reducer<CitiesAutoCompleteState> = (state = initialState, action) => {
  switch (action.type) {
    case CITIES_AUTO_COMPLETE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case CITIES_AUTO_COMPLETE_SUCCESSFUL:
      return {
        ...state,
        bySearch: action.payload,
        isLoading: false,
      };
    case CITIES_AUTO_COMPLETE_FAILURE:
      return {
        ...state,
        error: action.payload,
        bySearch: [],
        isLoading: false,
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

const persistConfig = {
  storage,
  version: 1,
  key: 'citiesAutoComplete',
  blacklist: ['isLoading', 'error'],
};

export default persistReducer(persistConfig, reducer);
